import { render, staticRenderFns } from "./CommunityHealthInfoUpdate.vue?vue&type=template&id=1e4a438f&"
import script from "./CommunityHealthInfoUpdate.vue?vue&type=script&lang=js&"
export * from "./CommunityHealthInfoUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CommunityHealthInfoUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports